import React, { useState, Component } from 'react';
import { SafeAreaView, View, Text, StyleSheet, Button, Image, Alert, Platform, Picker } from 'react-native';
import Amplify, { Auth, Cache, input, Logger, Storage} from 'aws-amplify';
import { API, graphqlOperation } from '@aws-amplify/api';
import { Assets } from '@react-navigation/stack';
//import { Picker } from '@react-native-picker/picker';
import EStyleSheet, { create } from 'react-native-extended-stylesheet';
import config from '../../src/aws-exports';
import mainIcon from '../assets/uploadifierSymbol.png';
import SelectFileButton from '../components/SelectFileButton'
import SignOutButton from '../components/SignOutButton'
import CheckUserButton from '../components/CheckUserButton';
import ReportedServiceInputField from '../components/ReportedServiceInputField';
import ReportedNumberInputField from '../components/ReportedNumberInputField';
import ReportedEmailInputField from '../components/ReportedEmailInputField';
import ReportedUsernameInputField from '../components/ReportedUsernameInputField';
import ReportedFirstnameInputField from '../components/ReportedFirstnameInputField';
import ReportedLastnameField from '../components/ReportedLastnameField';
import ReportedCommentInputField from '../components/ReportedCommentInputField';
import ReportedPhoneNumberInputField from '../components/ReportedPhoneNumberInputField';
import UploadButton from '../components/UploadButton';
import VerifyUploadButton from '../components/VerifyUploadButton';
import awsmobile from '../../src/aws-exports';
import { createUpload } from '../graphql/mutations';
import validate from 'validate.js';
import PhoneInput from 'react-phone-number-input/react-native-input';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import DropDownPicker from 'react-native-dropdown-picker';
import * as FileSystem from 'expo-file-system';




export default function UploadFile({ navigation, updateAuthState }) {
  const [inputreportedservice, setReportedservice] = useState('');
  const [inputreportednumber, setReportedNumber] = useState();
  const [inputreportedemail, setReportedEmail] = useState('');
  const [inputreportedusername, setReportedUsername] = useState('');
  const [inputreportedfirstname, setReportedFirstname] = useState('');
  const [inputreportedlastname, setReportedLastname] = useState('');
  const [inputreportedcomment, setReportedComment] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [shouldShowSubmit, setShouldShowSubmit] = useState(false);
  const [shouldShowPicker, setShouldShowPicker] = useState(true);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);
  const [items, setItems] = useState([
    {label: 'Bumble', value: 'Bumble'},
    {label: 'Discord', value: 'Discord'},
    {label: 'eHarmony', value: 'eHarmony'},
    {label: 'Email', value: 'Email'},
    {label: 'Facebook', value: 'Facebook'},
    {label: 'Grindr', value: 'Grindr'},
    {label: 'Imgur', value: 'Imgur'},
    {label: 'Instagram', value: 'Instagram'},
    {label: 'Linkedin', value: 'Linkedin'},
    {label: 'Match', value: 'Match'},
    {label: 'Parler', value: 'Parler'},
    {label: 'PoF', value: 'PoF'},
    {label: 'Reddit', value: 'Reddit'},
    {label: 'Snapchat', value: 'Snapchat'},
    {label: 'Text', value: 'Text'},
    {label: 'TikTok', value: 'TikTok'},
    {label: 'Tumblr', value: 'Tumblr'},
    {label: 'Tinder', value: 'Tinder'},
    {label: 'Twitter', value: 'Twitter'},
    {label: 'Twitch', value: 'Twitch'},
    {label: 'YouTube', value: 'YouTube'},
    {label: 'Other', value: 'Other'}
  ]);
  var nullcaseCounter = 0;
  var submitEnableBool = false;
  var pickerDisableBool = false;


  function submissionEnable(){

    console.log('verify counter was reset, 0 is the correct number:', nullcaseCounter)
    nullcaseCounter = 0;

    //required fields for valdate.js 
    var constraints = {
      from: {
        email: true
      }
    };

// const constraints = {
//  emailAddress: {
//    presence: {
//      allowEmpty: false,
//      message: "^Please enter an email address"
//    },
//    email: {
//      message: "^Please enter a valid email address"
//    }
//  },
//};
    if (typeof inputreportednumber === 'undefined'){
      console.log('null phone number', nullcaseCounter)
      nullcaseCounter = nullcaseCounter + 1;
      }

    if (typeof inputreportednumber !== 'undefined' && inputreportednumber !== null){
      if (isPossiblePhoneNumber(inputreportednumber) !== true){
        console.log('not a possible valid phone number', nullcaseCounter)
        nullcaseCounter = nullcaseCounter + 1;
        if (Platform.OS === 'android' || Platform.OS === 'ios'){
          Alert.alert("Please enter a valid phone number, or leave the field blank.");
        }
        if (Platform.OS === 'web'){
          alert("Please enter a valid phone number, or leave the field blank.")
        }
      }
  
    if (isPossiblePhoneNumber(inputreportednumber) === true){
      console.log('possible valid phone number', nullcaseCounter)
      }
    }  

  if (inputreportedemail === ''){
    console.log('email field is null')
    nullcaseCounter = nullcaseCounter + 1;

  }
      
  if(inputreportedemail !== null && inputreportedemail !== ''){
    const validationResult = validate({from: inputreportedemail}, constraints)
        if (typeof validationResult=== 'undefined'){
          nullcaseCounter = nullcaseCounter + 0;
          console.log('Email is valid')
        
        }

      
        if (typeof validationResult !== 'undefined'){
          nullcaseCounter = nullcaseCounter + 1;
          console.log('Email is Not valid')
          if (Platform.OS === 'android' || Platform.OS === 'ios'){
            Alert.alert("Please enter a valid email address, or leave the field blank.");
          }
          if (Platform.OS === 'web'){
            alert("Please enter a valid email address, or leave the field blank.")
          }
    }
  }

  if (inputreportedusername === ''){
    console.log('username field is null')
    nullcaseCounter = nullcaseCounter + 1;

  }

  if(nullcaseCounter > 2){
    if (Platform.OS === 'android' || Platform.OS === 'ios'){
      Alert.alert("A submission needs an email, phone# or Username to be part of the submission. Please enter one to continue");
      console.log("check the bool state" , submitEnableBool)
      return submitEnableBool;
    }
    if (Platform.OS === 'web'){
      alert("A submission needs an email, phone# or Username to be part of the submission. Please enter one to continue");
      console.log("check the bool state" , submitEnableBool)
      return submitEnableBool;
    }


  }

  if(nullcaseCounter <= 2){
    if (Platform.OS === 'android' || Platform.OS === 'ios'){
      Alert.alert("Thank you for the report. Please hit upload below")
      submitEnableBool = true
      console.log("check the bool state" , submitEnableBool)
      //return submitEnableBool;
      setShouldShowSubmit(submitEnableBool);
      setShouldShowPicker(pickerDisableBool);
    }
    if (Platform.OS === 'web'){
      alert("Thank you for the report. Please hit upload below")
      submitEnableBool = true
      console.log("check the bool state" , submitEnableBool)
      //return submitEnableBool;
      setShouldShowSubmit(submitEnableBool);
      setShouldShowPicker(pickerDisableBool);
    }
  }
  
    else {
      console.log('fell through all the other cases, this should not happen')
    };
    
    console.log("final count, after checking number, user and email fields:", nullcaseCounter);
  }

  if(submitEnableBool === true){
    
  }

async function submitEnable(){
  submissionEnable();
  console.log("Checking output of function" , submissionEnable())
}  


  async function addUpload() {  

    await Auth.currentAuthenticatedUser({
      bypassCache: true  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
     }).then(user => console.log(user))
     .catch(err => console.log(err));
      
    try {
      var reportinguser = Auth.user.attributes.email;
      //var reportedservice = inputreportedservice;
      var reportedservice = value
      var reportednumber = inputreportednumber;
      var reportedemail = inputreportedemail;
      var reportedusername = inputreportedusername;
      var reportedfirstname = inputreportedfirstname;
      var reportedlastname = inputreportedlastname;
      var reportedcomment = inputreportedcomment;
      
      var uploadDetails = {
        reportinguser: Auth.user.attributes.email,
        //reportedservice: inputreportedservice,
        reportedservice: value,
        reportednumber: inputreportednumber,
        reportedemail: inputreportedemail,
        reportedusername: inputreportedusername,
        reportedfirstname: inputreportedfirstname,
        reportedlastname: inputreportedlastname,
        reportedcomment: inputreportedcomment,
      };
      console.log('reporting username:' , reportinguser);
      console.log('reported service:' , reportedservice);
      console.log('reported number:' , reportednumber);
      console.log('reported email:' , reportedemail);
      console.log('reported username:' , reportedusername);
      console.log('reported first name:' , reportedfirstname);
      console.log('reported last name:' , reportedlastname);
      console.log('reported comment:' , reportedcomment);


    const response: any = await API.graphql(graphqlOperation(createUpload, {input: uploadDetails}));
    // take transaction ID, and prep it to be used as the file name we are about to upload
    const transactionUid = response.data.createUpload.id;  
    
    //grab the image to upload
    const imageresponse = await fetch(imageURIForUpload);
    const blob = await imageresponse.blob();
    //do the actual upload
    await Storage.put("Staging/" + transactionUid +".jpg", blob, {
      contentType: 'image/jpeg', // contentType is optional
      //console.log(`Uploaded: ${progress.loaded}/${progress.total}`); <<< this does not work yet. 
      });
      Alert.alert("Image and report submitted. Thank you.")
      navigation.navigate('Home');
    } catch (err) {
        //console.log(selectedImage);
      console.log('Error uploading file:', err);
    }
   
   
  }
  
  
    return (
      <View style={styles.container}>
        <Text>  Tell us where the message came from, then fill in a couple more details a out who sent this to you so.</Text>  
  
      <DropDownPicker
        style={{
          backgroundColor: "#1bb3f9",
          borderRadius: 25,
          flexDirection: 'row',
          justifyContent: 'center',
          padding: '1%',
          width: '85%',
          alignItems: 'center',
          textAlign: 'center',
          alignSelf: 'center'
        }}
        placeholder="CHOOSE A SERVICE"
        placeholderStyle={{
          color: "white",
          fontWeight: "bold"
        }}
        open={open}
        value={value}
        items={items}
        setOpen={setOpen}
        setValue={setValue}
        setItems={setItems}       
      />       

        <PhoneInput
        style={styles.phone}
          country="US"
          leftIcon="phone"
          placeholder="Senders Phone Number"
          placeholderTextColor='#6e6869'
          value={inputreportednumber}
          onChange={setReportedNumber}
        />
         <ReportedEmailInputField
         style={styles.textinput}
          value={inputreportedemail}
          onChangeText={text => setReportedEmail(text)}
          leftIcon="email"
          placeholder="Senders Email Address"
          autoCapitalize="none"
          textContentType="emailAddress"
          
        />
        <ReportedUsernameInputField
        style={styles.textinput}
          value={inputreportedusername}
          onChangeText={text => setReportedUsername(text)}
          leftIcon="account"
          placeholder="Senders Username"
          autoCapitalize="none"
          autoCorrect={false}
          
        />
         <ReportedFirstnameInputField
         style={styles.textinput}
          value={inputreportedfirstname}
          onChangeText={text => setReportedFirstname(text)}
          leftIcon="badge-account-horizontal"
          placeholder="Senders First Name"
          autoCapitalize="none"
          textContentType="givenName"
          
        />
        <ReportedLastnameField
        style={styles.textinput}
          value={inputreportedlastname}
          onChangeText={text => setReportedLastname(text)}
          leftIcon="badge-account-horizontal-outline"
          placeholder="Senders Last Name"
          autoCapitalize="none"
          autoCorrect={false}
          textContentType="familyName"
          
        />
        <ReportedCommentInputField
          value={inputreportedcomment}
          multiline={true}
          numberOfLines={4}
          onChangeText={text => setReportedComment(text)}
          leftIcon="comment"
          placeholder="Describe What Happened"
          autoCapitalize="none"
          autoCorrect={false}
          textContentType="none"
          
        /> 
        <VerifyUploadButton 
          title="Confirm Details" 
          color="#1bb3f9" 
          onPress={submissionEnable} 
        />

        {shouldShowSubmit ? (
        <UploadButton 
          title="Upload" 
          color="#1bb3f9" 
          onPress={addUpload} disabled={true}
        />
        ) : null}

        {shouldShowSubmit ? (
        <Text>  Hit Back in the upper left hand corner if you need to edit any details before submitting.</Text>  
        ) : null}

  </View>
    );
}


  
const styles = EStyleSheet.create({
    container: {
      flex: 1,
      flexWrap: 'wrap',
      textAlign: 'center',
      marginTop: 10
    },
    phone: {
      backgroundColor: '#f9f9f9',
      borderRadius: 25,
      flexDirection: 'row',
      marginVertical: '.25rem',
      padding: '1%',
      width: '20rem',
      height: '3rem',
      fontSize: '1.15rem',
      color: '#101010'
    },
    textinput: {
      backgroundColor: '#f9f9f9',
      flexDirection: 'row',
      padding: 0,
      width: '20rem',
      height: '2rem',
      fontSize: '1.15rem',
      color: '#101010'
    },
    commenttextinput: {
      backgroundColor: '#f9f9f9',
      borderRadius: 25,
      flexDirection: 'row',
      padding: '1rem',
      marginVertical: '.25rem',
      width: '20rem',
      height: '100%',
      fontSize: '1.15rem',
      color: '#101010'
    },
    title: {
      fontSize: 20,
      color: '#202020',
      fontWeight: '500',
      marginVertical: 15
    }
  });
    